import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonComponent } from '../../@core/components/ui/button/button.component';
import { AuthenticationService } from '../../@core/services/authentication.service';
import { ToastService } from '../../@core/services/toast.service';
import { TextCasePipe } from "../../@shared/pipes/textCase.pipe";
import { CaseType } from '../../@shared/services/case-format.service';
import { AssetUrlPipe } from 'src/app/@shared/pipes/asset-url.pipe';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [FormsModule, CommonModule, ButtonComponent, ReactiveFormsModule, InputTextModule, RouterModule, TextCasePipe, AssetUrlPipe],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  resetForm!: FormGroup;

  CASE_TYPE = CaseType;

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.resetForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email])
    });
  }

  get f() {
    return this.resetForm.controls;
  }

  onSubmit(): void {
    if (!this.resetForm.valid) {
      this.resetForm.markAllAsTouched();
      return;
    }

    const { email } = this.resetForm.value;
    this.authService.sendVerificationEmail(email).subscribe({
      next: (res) => {
        if (res.success) this.toastService.success('Reset Password sent successfully', 'Success');
        this.resetForm.reset()
      },
      error: (err) => {
        this.toastService.error('Reset Password failed', 'Error');
      }
    });

  }


  redirect(path: string) {
    this.router.navigate([path]);
  }

}
